import React, {useState} from 'react'
import {
    getGlobalMoneyObject,
    getPathAndQueryParams,
    objectLang,
    setErrorWindow, setLocalStorageItem,
    setMoneyMonthDetailPath,
    setMoneyPathBack
} from "../functions"
import {ModalWin} from "../elements/ModalWin"
import {YearMoneyClass} from "../components/YearMoneyClass"

export const YearMoneyPage = () => {
    setLocalStorageItem('page', 'YearMoneyPage')
    setMoneyPathBack(getPathAndQueryParams())
    setMoneyMonthDetailPath(getPathAndQueryParams())
    const lang = objectLang().language
    const l = lang.lang
    const [dataModal, setDataModal] = useState({})
    const urlParams = new URLSearchParams(window.location.search)
    const year = Number(urlParams.get('year'))
    let dataYear = {}

    const preYear = year - 1
    const nextYear = year + 1

    const globalMoneyObject = getGlobalMoneyObject()
    if (globalMoneyObject) {
        dataYear = {[year]: globalMoneyObject[year]}
    } else {
        setDataModal(setErrorWindow('', 999, 'Упсс... Что-то пошло не так!', '', `replaceTo /${l}/`))
        return (
            <ModalWin data={dataModal}/>
        )
    }

    return (
        <>
            <YearMoneyClass
                lang={lang}
                dataYear={dataYear}
                preYear={preYear}
                nextYear={nextYear}
                pathBack={`/${l}/money/main`}
            />
        </>
    )
}